export default {
  TYPE_BASE: 'type_base',
  TYPE_OVERVIEW: 'type_overview',
  TYPE_PROS_CONS: 'type_pros_cons',
  TYPE_KEY_FEATURES: 'type_key_features',
  TYPE_SNIPPETS: 'type_snippets',
  TYPE_PRICING: 'type_pricing',
  TYPE_SLIDER: 'type_slider',
  TYPE_INTEGRATIONS: 'type_integrations',
  TYPE_OPTIONS: 'type_options',
  TYPE_ALTERNATIVES: 'type_alternatives',
  TYPE_COMPARISONS: 'type_comparisons',
  TYPE_FAQS: 'type_faqs',
  TYPE_METHODOLOGY: 'type_methodology',
  TYPE_CATGORIES: 'type_categories',
  TYPE_RELATED_ARTICLES: 'type_related_articles',
  TYPE_AUTHORS: 'type_authors',
}
